import { AuthContext } from '@experiences/util';
import { useSignoutRedirect } from '@uipath/auth-react';
import React, { useCallback } from 'react';

import useUserInfo from '../hooks/UserInfo';

const IdentityAuthProvider: React.FC = ({ children }) => {
    const { token } = useUserInfo();
    const signoutRedirect = useSignoutRedirect();

    const logout = useCallback(
        (returnUrl?: string) => {
            signoutRedirect({ post_logout_redirect_uri: returnUrl });
        },
        [ signoutRedirect ],
    );

    return (
        <AuthContext.Provider
            value={{
                token,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export default IdentityAuthProvider;

